import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/$org/assets')({
    component: AssetsLayout,
})

function AssetsLayout() {
    return <Outlet />
} 